export default function getResource(label) {
    const resources = {
        mlActivated: 'LM ACTIVÉ'
    };

    return resources[label];
}
